/**
 * Dependency injection
 */
import * as React from 'react';
export class Inject extends React.PureComponent {
    // eslint-disable-next-line
    render() {
        return null;
    }
}
Inject.isService = true;
